let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lG0jb")).then(() => parcelRequire('4e6Iv'));